import React,{useState,useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { useDispatch,useSelector } from 'react-redux'
import {selectColegioStatus,selectAnioStatus} from './actions'
import { BreadCrumb } from 'primereact/breadcrumb';

const AppTopbar = (props) => {

    const items = [
        {label: 'Computer'},
        {label: 'Notebook'},
        {label: 'Accessories'},
        {label: 'Backpacks'},
        {label: 'Item'}
    ];

    const home = { icon: 'pi pi-home', url: 'https://www.primefaces.org/primereact/showcase' }

    const dispatch = useDispatch();
    const history = useHistory();

    const goDashboard = () => {
        history.push('/');
    };

    const {usuario} = useSelector(state => ({
        usuario: state.usuario
     }))

    const [colegio, setColegio] = useState(null);
    const [dataColegio, setDataColegio] = useState([]);

    const [anio, setAnio] = useState(null);
    const [dataAnio, setDataAnio] = useState([]);

    useEffect(() => {
       
        if(JSON.stringify(usuario)=='{}'){
            history.push('/');
        }else{
            setColegio(usuario.colegios.length > 0 ? usuario.colegios[0]:null);
            setDataColegio(usuario.colegios.length > 0 ? usuario.colegios:[]);
            dispatch(selectColegioStatus(usuario.colegios.length > 0 ? usuario.colegios[0]:{}));
        };

    }, []);

    useEffect(() => {
         if(colegio!=null){
            let anioo =  usuario.anios.filter(obj => obj.idcolegio == colegio.id)
            setAnio(anioo.length > 0 ? anioo[0]:null);
            setDataAnio(anioo.length > 0 ? anioo:[]);
            dispatch(selectAnioStatus(anioo.length > 0 ? anioo[0]:{}));
        }
    }, [colegio,usuario.anios]);

    const selectColegio = (e) => {
        setColegio(e);
        dispatch(selectColegioStatus(e));
    };

    const selectAnio = (e) => {
        setAnio(e);
        dispatch(selectAnioStatus(e));
    };

    const cerrarSesion = () => {
        localStorage.clear();
        history.push('/')
        window.location.reload(true);
    };

    const topbarItemsClassName = classNames('topbar-items fadeInDown', { 'topbar-items-visible': props.topbarMenuActive });
    const profileItemClassName = classNames('profile-item', { 'active-top-menu': props.activeTopbarItem === 'profile' });
    return (
        <div className="topbar clearfix">
            
            <div className="topbar-left">
                <button className="p-link" onClick={goDashboard}>
                    <img alt="Logo" src="assets/layout/images/logo.png" className="topbar-logo" />
                </button>
            </div>

            <div className="topbar-right">
                
                <button className="p-link" id="menu-button" onClick={props.onMenuButtonClick}>
                    <i className="pi pi-angle-left"></i>
                </button>
                <button className="p-link" id="topbar-menu-button" onClick={props.onTopbarMenuButtonClick}>
                    <i className="pi pi-bars"></i>
                </button>

                <ul className={topbarItemsClassName}>
                    {
                        (props.profileMode === 'top' || props.horizontal) && (
                            <li className={profileItemClassName} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'profile' })}>
                                <button className="p-link">
                                    <img alt="User" className="profile-image" src={usuario.foto===''?'assets/layout/images/fotovacio.png':usuario.foto} />
                                    <span className="topbar-item-name">{usuario.email}</span>
                                    <span className="topbar-item-role">{usuario.rolNombre}</span>
                                   {/* <span className="topbar-item-role">Educación</span>  */}
                                </button>
                                <ul className="layout-menu fadeInDown">
                                    <li role="menuitem">
                                        <button className="p-link" onClick={() => props.loadPageProfile()}>
                                            <i className="pi pi-fw pi-user"></i>
                                            <span>Profile</span>
                                        </button>
                                    </li>
                                    
                                    <li role="menuitem">
                                        <button className="p-link" onClick={cerrarSesion}>
                                            <i className="pi pi-fw pi-sign-out"></i>
                                            <span>Salir</span>
                                        </button>
                                    </li>
                                </ul>
                            </li>)
                    }

                   {/*  <li className={classNames({ 'active-top-menu': props.activeTopbarItem === 'settings' })} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'settings' })}>
                        <button className="p-link">
                            <i className="topbar-icon pi pi-fw pi-cog"></i>
                            <span className="topbar-item-name">Settings</span>
                        </button>
                        <ul className="layout-menu fadeInDown">
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-palette"></i>
                                    <span>Change Theme</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-star-o"></i>
                                    <span>Favorites</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-lock"></i>
                                    <span>Lock Screen</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-image"></i>
                                    <span>Wallpaper</span>
                                </button>
                            </li>
                        </ul>
                    </li> */}

                    <li className={classNames({ 'active-top-menu': props.activeTopbarItem === 'Anio' })} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'Anio' })}>
                        <button className="p-link" style={{ backgroundColor:'#2e7796',padding: '4px'}}>
                            <span style={{color: 'white',fontSize:'18px',fontweight:'bold',paddingLeft:'5px',width: '142px'}}>{anio==null?'----': anio.anio}</span>
                            <i className="topbar-icon pi pi-chevron-down" style={{marginLeft:'5px'}}></i>                       
                        </button>
                        <ul className="layout-menu fadeInDown">
                            
                                {
                                    dataAnio.map((a, index) => {

                                        return  <li key={index}  role="menuitem" >
                                                    <button key={index} className="p-link" style={{width: '142'}}  onClick={() => selectAnio(a)}> 
                                                        <i  className="pi pi-fw pi-palette"></i>
                                                        <span style={{color: 'while',fontsize:'19px',marginLeft:'7px',fontweight:'bold'}} > {a.anio}</span>
                                                    </button>
                                                </li>
                                    })
                              }
                        </ul>
                    </li>
                    <li className={classNames({ 'active-top-menu': props.activeTopbarItem === 'Colegio' })} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'Colegio' })}>
                        <button className="p-link" style={{ backgroundColor:'#2e7796',padding: '4px'}}>
                            <span style={{color: 'white',fontSize:'18px',fontweight:'bold',paddingLeft:'5px'}}>{colegio==null?'--': colegio.nombre}
                            </span>
                            <i className="topbar-icon pi pi-chevron-down" style={{marginLeft:'5px'}}></i>
                        </button>
                        
                        <ul className="layout-menu fadeInDown">
                            
                                {
                                    dataColegio.map((co, index) => {

                                        return  <li key={index}  role="menuitem" >
                                                    <button key={index} className="p-link" style={{width: '142'}}  onClick={() => selectColegio(co)}> 
                                                        <i  className="pi pi-fw pi-palette"></i>
                                                        <span style={{color: 'while',fontsize:'19px',marginLeft:'7px',fontweight:'bold'}} > {co.nombre}</span>
                                                    </button>
                                                </li>
                                    })
                              }
                        </ul>
                    </li>

                    

                   {/*  <li className={classNames({ 'active-top-menu': props.activeTopbarItem === 'messages' })} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'messages' })}>
                        <button className="p-link">
                            <i className="topbar-icon pi pi-fw pi-envelope"></i>
                            <span className="topbar-badge">5</span>
                            <span className="topbar-item-name">Messages</span>
                        </button>
                        <ul className="layout-menu fadeInDown">
                            <li role="menuitem">
                                <button className="p-link topbar-message">
                                    <img alt="Avatar 1" src="assets/layout/images/avatar1.png" width="35" />
                                    <span>Give me a call</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link topbar-message">
                                    <img alt="Avatar 2" src="assets/layout/images/avatar2.png" width="35" />
                                    <span>Sales reports attached</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link topbar-message">
                                    <img alt="Avatar 3" src="assets/layout/images/avatar3.png" width="35" />
                                    <span>About your invoice</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link topbar-message">
                                    <img alt="Avatar 4" src="assets/layout/images/avatar2.png" width="35" />
                                    <span>Meeting today at 10pm</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link topbar-message">
                                    <img alt="Avatar 5" src="assets/layout/images/avatar4.png" width="35" />
                                    <span>Out of office</span>
                                </button>
                            </li>
                        </ul>
                    </li>

                    <li className={classNames({ 'active-top-menu': props.activeTopbarItem === 'notifications' })} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'notifications' })}>
                        <button className="p-link">
                            <i className="topbar-icon pi pi-fw pi-bell"></i>
                            <span className="topbar-badge animated rubberBand">4</span>
                            <span className="topbar-item-name">Notifications</span>
                        </button>

                        <ul className="layout-menu fadeInDown">
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-sliders-h"></i>
                                    <span>Pending tasks</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-calendar"></i>
                                    <span>Meeting today at 3pm</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-download"></i>
                                    <span>Download documents</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-bookmark"></i>
                                    <span>Book flight</span>
                                </button>
                            </li>
                        </ul>
                    </li>

                    <li className={classNames('search-item', { 'active-top-menu': props.activeTopbarItem === 'search' })} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'search' })}>
                        <div className="topbar-search">
                            <input type="text" placeholder="Search" />
                            <i className="pi pi-search"></i>
                        </div>
                    </li>  */}
                </ul>
            </div>
        </div>
    );
}

export default AppTopbar;
